import type { PluginWebManifest } from '@reflex/plugin-api/web';
import { SLACK_CHANNEL_PARTICIPANT_SHARING } from './shared/session-sharing.js';

export const slackWeb: PluginWebManifest = {
  // Both the wizard slide-over and the plugin detail page mount this
  // same component so the workspace-install UI is identical in both
  // surfaces.
  orgSetupComponent: {
    componentPath: '@reflex/plugin-slack/web/SlackSettingsPage',
    label:
      'Install the Slack app on a workspace so this org can run agents from Slack and post results back.',
  },
  // The org Sharing page renders a switch for this from the declaration
  // itself; the same object is on the server definition, which owns the
  // storage and the clamp. See `shared/session-sharing.ts`.
  sessionSharingSettings: [SLACK_CHANNEL_PARTICIPANT_SHARING],
  settingsSections: [
    {
      id: 'slack-notifications',
      label: 'Notifications',
      icon: 'Bell',
      componentPath: '@reflex/plugin-slack/web/SlackNotificationSettings',
      order: 10,
    },
  ],
  // Chip for the `slack_thread` association kind (a thread an agent holds a
  // ref to), rendered wherever an agent's linked work items show.
  associationChips: [
    {
      kind: 'slack_thread',
      label: 'Slack thread',
      componentPath: '@reflex/plugin-slack/web/SlackThreadAssociationChip',
    },
  ],
  flowTriggerRenderers: [
    {
      triggerType: 'slack_message',
      label: 'Slack message',
      icon: 'MessageSquare',
      componentPath: '@reflex/plugin-slack/web/SlackFlowTriggerSummary',
    },
  ],
  eventLabels: [
    {
      type: 'agent.source.slack',
      label: 'From Slack',
      tooltip: 'Agent triggered from a Slack message',
      style: 'system',
    },
  ],
  marketingPreviews: [
    {
      id: 'slack-workspace-card',
      label: 'Slack workspace card',
      description:
        'Sample connected workspace with Slack-triggered agent activity, stats, and recent runs.',
      surface: 'card',
      componentPath: '@reflex/plugin-slack/web/SlackWorkspaceCardPreview',
    },
  ],
};
